import React from 'react';
import { Box } from '@mui/material';

export default function StyledChip({
  onClick,
  children
}: {
  onClick?: () => void;
  children: React.ReactNode;
}) {
  return (
    <Box
      style={{
        padding: '5px 10px',
        cursor: 'pointer',
        borderRadius: '26px',
        zIndex: 1,
        marginLeft: '-10px',
        border: '10px solid #FFFFFF',
        backgroundColor: '#F5F5F5'
      }}
      onClick={() => onClick && onClick()}
    >
      {children}
    </Box>
  );
}
